import { appendQueryString, IReturn, nameOf } from "@servicestack/client";
import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { IOnlinePatientManagement, OnlinePatientManagementContext } from "@ngt/opms";
import { useMemo, useCallback, useContext } from 'react';
import IHttpVerb from "../../types/IHttpVerb";

const SwrClient = {
    api: <T>(httpVerb: IHttpVerb, fn?: (opms: IOnlinePatientManagement) => IReturn<T>, configuration?: SWRConfiguration | undefined) => {
        const opms = useContext(OnlinePatientManagementContext);

        const request = useMemo(() => {
            if (!fn) {
                return null;
            }

            return fn(opms);
        }, [fn])
        
        const key = useMemo(() => {
            if (!request) {
                return null;
            }

            return appendQueryString(`SwrClient:${httpVerb}:${nameOf(request)}`, request);
        }, [request, httpVerb]);

        // @ts-ignore
        const fetcher = useCallback((key: string) => {
            if (!request) { 
                return null 
            }

            return opms.serviceStackClient[httpVerb](request) 
        }, [request])

        return useSWR(key, fetcher, configuration) as SWRResponse<T, T>
    }
}

const useSwrClient = () => {
    return SwrClient;
};

export default useSwrClient;